import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import PageLoader from "../../components/common/loader/pageLoader";
import WaitingComponent from "../../components/waiting";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { getProfileApi } from "../../services/profile.service";
import { storeUserData } from "../../store/slice/profile.slice";
import handleNavigation from "../../utils/paymentNavigation";

interface WaitingScreenInterface {}

const WaitingScreen: React.FC<WaitingScreenInterface> = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const state = useAppSelector((state) => state);
  const { userData }: { userData?: any } = state.profile;

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = () => {
    setLoading(true);
    dispatch(
      getProfileApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data?: any) => {
          const r = localStorage.getItem("r");
          const winner_token = localStorage.getItem("winner_token");
          console.log("r", r, winner_token);
          navigate(
            handleNavigation(
              data?.survey_status,
              data?.has_store,
              data?.lucky_draw_status
            ),
            { state: { r, winner_token } }
          );
        },
        unauthenticatedCallback: () => {
          handleLogout();
        },
      })
    );
  };

  const handleLogout = () => {
    dispatch(storeUserData({}));
    localStorage.clear();
    window.location.replace("https://missingskincare.com");
    setLoading(true);
  };

  const handleLogin = () => {
    navigate("/login");
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <WaitingComponent
      fetchProfile={fetchProfile}
      loading={loading}
      handleLogout={handleLogout}
      handleLogin={handleLogin}
      userData={userData}
    />
  );
};

export default WaitingScreen;
